import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core'
import EditIcon from '../../assets/images/icons/edit.svg'
// import EditIcon from '../../assets/images/icons/edit.svg'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { formatNumber, ROUTES, formatDate, getSampleCsvHeadings } from '../../shared/constants'
import CustomViewForm from '../../components/CustomViewForm'
// import CustomTableLayout from '../../components/CustomTableLayout'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import { UseTmpOrder } from '../../hooks/tmpOrder/useTmpOrder'
import { TmpOrderContext } from '../../context api/TmpOrder/TmpOrderContext'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'

export default function MyTempOrders() {
  //use reducer
  const { getAllTmpOrder, deleteAll, deleteMultiple, pdfCsvData, setPdfCsvData } = UseTmpOrder()
  const { tmpOrders, loading } = useContext(TmpOrderContext)
  const [searchQuery, setSearchQuery] = useState('')
  const filterOrders = tmpOrders
  const [page, setPage] = React.useState(1)
  const redirectUrl = 'GET_ALL_CATEGORIES'
  const noOfPages = 100
  const tableHeadings = [' ', 'Quantity', 'SKU', 'Price', 'Category', 'Sub Category', 'Channel Type', 'Channel Name', 'Code']
  const [data, setData] = useState([])
  const [tableData, setTableData] = useState([])
  const tempHeaders = getSampleCsvHeadings(['Quantity', 'SKU', 'Price', 'Category', 'Sub Category', 'Channel Type', 'Sales Channel Name', 'Placed At'])
  const history = useHistory()
  const [deleteList, selectDeleteList] = useState([])
  const [multipleDeleteDialog, setMultipleDeleteDialog] = useState(false)
  const limit = 15

  useEffect(() => {
    console.log('getting page', page, tmpOrders)
    getAllTmpOrder({ page: page, limit: limit, searchQuery })
  }, [page, searchQuery])

  const styles = {
    // width: "100%",
    // display: "flex",
    // backgroundColor: "pink",
    border: '1px solid gray',
    // borderRight: "1px dash gray",
    // borderStyle: "solid 1",

    // overflow: "scroll",
  }
  useEffect(() => {
    let tableBody = []
    console.log(tmpOrders, loading)
    if (tmpOrders) {
      tableBody = tmpOrders.map((item) => {
        return [
          { type: 'CHECKBOX', _id: item._id, style: styles },
          { value: item.channelType.name, style: styles },
          { value: item.channelName ? item.channelName.name : 'NA', style: styles },
          { value: item.qty, style: styles },
          {
            value: item.product.map((prod) => {
              return prod.sku + ', '
            }),
            id: item._id,
            style: styles,
          },
          { value: formatNumber(item.price), style: styles },
          {
            value: item.category.map((cat) => {
              return cat.categoryName + ', '
            }),
            style: styles,
          },
          { value: item.subCategory.map((sub) => sub.name + ', '), style: styles },

          { value: formatDate(item.createdAt), style: styles },
          // { type: 'INFO', onClick: () => history.push(`/view-tmp-order/${item._id}`), style: styles },
        ]
      })
      setTableData(tableBody)
      // console.log("========================>", tableBody);
    }
  }, [tmpOrders])
  useEffect(() => {
    console.log('tD========================>', tableData)
  }, [tableData])

  console.log('tableData', tableData)
  const layoutProps = {
    heading: 'Manage Orders',
    url: ROUTES.ADD_TMPORDER,
    editUrl: `/view-tmp-order/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaders: tempHeaders,
    tempHeaderData: [],
    filename: 'tmpOrders',
    sampleName: 'sample_tmpOrders',
    sheetName: 'tmpOrders',
    deleteData: deleteList,
    selectedData: deleteList,
    setMultipleDeleteDialog: setMultipleDeleteDialog,
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    // downloadLoading,
    redirectUrl: '/my-tmp-orders',
    // addData: addNewCategory,
    permissionName: 'ORDER',
  }
  const handleChange = (event, value) => {
    setPage(value)
  }

  return (
    <>
      {tableData && (
        <>
          <CustomTableLayout
            tableHeadings={['Channel Type', 'Channel Name', 'Quantity', 'Products', 'total Price', 'Category', 'SubCategory', 'Placed At']}
            loading={loading}
            tableBody={tableData}
            handleSwitchChange={() => {
              console.log('cant switch')
            }}
            handlePageChange={handleChange}
            paginate={{ totalPage: noOfPages, page: page }}
            layoutProps={layoutProps}
            checkbox
            deleteMany={(val, setSelected) => deleteMultiple({ ids: val }, setSelected)}
          />
        </>
      )}
      {/* <Layout {...layoutProps} heading="Temp Orders" heading2="Info" url1={ROUTES.ADD_TMPORDER} none>
       <CustomTable style ={{overflow : "scroll"}}>
         <CustomTableHeading heading={tableHeadings} />
         <TableBody>
           {tableData.length !== undefined && tableData.length!= 0 
           ? tableData.map((val) => (
             <TableRow>
               <TableCell 
                onClick= {()=>{
                  console.log("val", val)
                   history.push(`/view-tmp-order/${val[1].id}`)
                   }}> <img src= {EditIcon}/> </TableCell>
               {val.map((val2) => {
                 if(val2.type=== 'CHECKBOX')
                 return <>
                        <Checkbox
                              onClick={(event) => {
                                selectDeleteList((deleteList)=>{
                                  return [...deleteList, val2.id]
                                })
                                 console.log("checked", val2.id)
                                 console.log(deleteList);
                              }}
                            />
                            {val2.value}
                        </> 
                 return <TableCell > {val2.value} </TableCell>
               })}
             </TableRow>
           ))
           :
           <TableRow> <TableCell variant= "footer"> No data found </TableCell></TableRow>
           }
         </TableBody>
       </CustomTable>
       <div style= {{alignItems: "center", textAlign: "center"}}>
          <button 
          style= {{borderRadius: "5px", border: "0px", color: "white", background: "gray", margin: "auto", fontSize: "10", padding: "5px", margin: "10px"}}
          onClick= {()=>{
            setPage((page)=>{ if(page > 1) return page-1 
              else return page});
          }}>
            Prev
          </button>
          {page}
          <button 
          style= {{borderRadius: "5px", border: "0px", color: "white", background: "gray", margin: "auto", fontSize: "14px", padding: "5px", margin: "10px"}}
          onClick= {()=>{
            setPage((page)=>{ if(page < noOfPages) return page+1
               else return page});
          }}>
            Next
          </button>
       </div>
       <ConfirmDialog open={multipleDeleteDialog} handleClose={() => setMultipleDeleteDialog(false)} handleSubmit={() => deleteMultiple({ids:deleteList})} />
       comment ------------------------------------------- /* <button 
       style= {{borderRadius: "5px", border: "0px", color: "white", background: "red", margin: "auto", fontSize: "14px", padding: "5px", margin: "10px"}}
       onClick= {()=>{
         deleteAll();
       }}>
         Delete All
       </button>


       <button 
       style= {{borderRadius: "5px", border: "0px", color: "white", background: "gray", margin: "auto", fontSize: "14px", padding: "5px", margin: "10px"}}
       onClick= {()=>{
        deleteMultiple(deleteList);
       }}>
         Delete
       </button>  -------------------------------------------------------comment       
    </Layout> */}
    </>
  )
}
